import { trimSafe, trimRight, trimLeft, toLowerCaseSafe } from "@/utils/index";

const isDevelopment = toLowerCaseSafe(process.env.NODE_ENV) === "development";
let appSettings = null;
// if (!isDevelopment) {
//   try {
//     appSettings = require("./settings-development.json");
//   } catch (ex) {
//     console.warn(
//       "In development mode, but failed to load settings-development.json. Will use default settings."
//     );
//   }
// }
// if (appSettings === null) {
//   console.log("appSetting null");
appSettings = require("./settings-default.json");
// }
const getApiURL = urlName => {
  if (!urlName) {
    throw "urlName not provided.";
  }

  let url = trimRight(trimSafe(appSettings[urlName]), ["/"]);
  return `${url}`;
};
const axiosTimeout = process.env.VUE_APP_AXIOS_TIMEOUT;

/**
 * Ensure Valid Api URL
 * @param {String} urlName
 * @returns {String}
 */
function ensureValidApiURL(urlName) {
  if (!urlName) {
    throw "urlName not provided.";
  }
  return trimRight(trimSafe(urlName), ["/"]);
}

/**
 * Application version defined in vue.config.js
 * @type {String|string}
 */
const version = trimLeft(
  trimRight(process.env["VUE_APP_VERSION"] || "0", ['"']),
  ['"']
);

/**
 * Customer Name defined in vue.config.js
 * @type {String|string}
 */
const customerName = process.env["VUE_APP_CUSTOMER_NAME"] || "Customer Name";

/**
 * Year of the Application
 * @type {string}
 */
const appYear =
  process.env["VUE_APP_YEAR"] || new Date().getFullYear().toString();

export default appSettings;

export {
  getApiURL,
  isDevelopment,
  ensureValidApiURL,
  axiosTimeout,
  version,
  customerName,
  appYear
};
